/**
 *
 * Asynchronously loads the component for CompanyInfoPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
